import { combineEpics } from 'redux-observable';
import { loginEpic, logoutEpic } from './login';

export default combineEpics(loginEpic, logoutEpic);



// WEBPACK FOOTER //
// ./src/store/auth/epics/index.ts